import type { ICountryObject } from "app/services/CountryService";
import CountryService from "app/services/CountryService";

type UseEnrichmentCountriesProps = {
    localCountry: ICountryObject;
    setLocallySelectedCountry: (id: string) => void;
};

export const useEnrichmentCountries = (): UseEnrichmentCountriesProps => {
    const localCountry = CountryService.getCountryById(localStorage.getItem("enrichCountry"));

    const setLocallySelectedCountry = (countryId: string) => {
        localStorage.setItem("enrichCountry", countryId);
    };

    return { localCountry, setLocallySelectedCountry };
};
